import { render, staticRenderFns } from "./endereco-pessoa-deficiente-visual.vue?vue&type=template&id=400c2b15&"
import script from "./endereco-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./endereco-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400c2b15')) {
      api.createRecord('400c2b15', component.options)
    } else {
      api.reload('400c2b15', component.options)
    }
    module.hot.accept("./endereco-pessoa-deficiente-visual.vue?vue&type=template&id=400c2b15&", function () {
      api.rerender('400c2b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/endereco-pessoa-deficiente-visual.vue"
export default component.exports